module.exports = __webpack_public_path__ + "static/img/home_bg.998d31a5.jpeg";